"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Protected_exports = {};
__export(Protected_exports, {
  Group: () => Group,
  Protected: () => Protected,
  isProtectedElement: () => isProtectedElement
});
module.exports = __toCommonJS(Protected_exports);
var import_core = require("@react-navigation/core");
var import_react = require("react");
var import_children = require("../headless/children");
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var { Group } = (0, import_core.createNavigatorFactory)({})();
var Protected = Group;
Object.assign(Protected, {
  [import_children.NAVIGATOR_CONFIG]: true
});
function isProtectedElement(child) {
  return Boolean(/* @__PURE__ */ (0, import_react.isValidElement)(child) && child.type === Group && child.props && _type_of(child.props) === "object" && "guard" in child.props);
}
//# sourceMappingURL=Protected.js.map
